"use client";

import { useEffect, useState } from 'react';

type Consent = {
    ads: boolean;
    date: string;
};

const CONSENT_KEY = 'cookie_consent';

function getStoredConsent(): Consent | null {
    if (typeof window === 'undefined') return null;
    try {
        const raw = localStorage.getItem(CONSENT_KEY);
        if (!raw) return null;
        return JSON.parse(raw) as Consent;
    } catch {
        return null;
    }
}

export function hasAdsConsent(): boolean {
    const stored = getStoredConsent();
    // Default-block for compliance: show ads only when explicitly accepted
    return stored?.ads === true;
}

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const stored = getStoredConsent();
        setVisible(!stored);
    }, []);

    const storeConsent = (ads: boolean) => {
        try {
            const value: Consent = { ads, date: new Date().toISOString() };
            localStorage.setItem(CONSENT_KEY, JSON.stringify(value));
            window.dispatchEvent(new CustomEvent('consentchange', { detail: value }));
        } catch {}
    };

    if (!visible) return null;

    return (
        <div className="fixed inset-x-0 bottom-0 z-50">
            <div className="container mx-auto px-4 pb-4">
                <div className="bg-white border shadow-lg rounded-lg p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3">
                    <div className="text-sm text-gray-700">
                        We use cookies and similar technologies to provide core features and serve ads. You can change your choice anytime in our <a href="/cookies" className="underline hover:text-blue-600">Cookie Policy</a>.
                    </div>
                    <div className="flex items-center gap-2 sm:ml-auto">
                        <button
                            className="px-3 py-2 text-sm rounded border hover:bg-gray-50"
                            onClick={() => {
                                storeConsent(false);
                                setVisible(false);
                            }}
                        >
                            Decline
                        </button>
                        <button
                            className="px-3 py-2 text-sm rounded bg-blue-600 text-white hover:bg-blue-700"
                            onClick={() => {
                                storeConsent(true);
                                setVisible(false);
                            }}
                        >
                            Accept
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}


